import { Schema } from './get_schema.js';

const locId = Schema.Int;
const picid = Schema.NotEmptyString;
const shareableId = Schema.Int;
const tripId = Schema.Int;
const userId = Schema.Int;

const entityId = Schema.Int;
const entityType = Schema.Enum('checklist', 'menu');

const email = Schema.Email;
const rights = Schema.Set('', 'read', 'write', 'share', 'all');

const invitee = Schema.Object({
  inviteeUserId: Schema.Optional(userId),
  inviteeEmail: Schema.Optional(email),
  rights,
});
const invitees = Schema.Array(invitee);

const inviteHash = Schema.NotEmptyString;
const inviteHashes = Schema.Array(inviteHash);

export {
  Schema,
  locId,
  picid,
  shareableId,
  tripId,
  entityId,
  entityType,
  userId,
  email,
  rights,
  invitee,
  invitees,
  inviteHash,
  inviteHashes,
};
